module.exports = __webpack_public_path__ + "assets/img/elem6-transperent-bcg.16edd521.png";